var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4",attrs:{"id":"pdf-wrapper"}},[_c('signature-box',{staticClass:"d-none",attrs:{"id":"signatureBox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }